<script setup lang="ts"></script>

<template>
  <svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_13170_10524)">
      <path
        d="M72.1183 34.4179C73.1165 48.6924 62.3256 60.2642 48.0162 60.2642C33.7068 60.2642 21.2976 48.6924 20.2994 34.4179C19.3012 20.1433 30.0921 8.57153 44.4015 8.57153C58.7109 8.57153 71.1202 20.1433 72.1183 34.4179Z"
        fill="#FFBF3C"
      />
      <path
        d="M96.435 102.212C96.0184 96.2539 94.4295 90.3544 91.7591 84.8501C89.0886 79.3457 85.3889 74.3444 80.8712 70.1315C76.3535 65.9187 71.1062 62.5769 65.429 60.2969C59.7518 58.0169 53.7558 56.8434 47.7834 56.8434C41.811 56.8434 35.9791 58.0169 30.6208 60.2969C25.2624 62.5769 20.4825 65.9187 16.554 70.1315C12.6255 74.3444 9.62521 79.3457 7.72457 84.8501C5.82393 90.3544 5.06012 96.2539 5.47673 102.212H96.435Z"
        fill="#FFBF3C"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M41.3373 27.1989C38.1002 24.5682 34.453 25.5629 32.7769 27.1784C32.2631 27.6735 31.4132 27.6314 30.8786 27.0844C30.344 26.5373 30.3271 25.6924 30.8408 25.1973C33.2111 22.9129 38.3631 21.4516 42.9468 25.1768C43.5403 25.6591 43.6611 26.5028 43.2166 27.0612C42.7722 27.6195 41.9308 27.6812 41.3373 27.1989Z"
        fill="#37241F"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M40.6409 45.3793C43.9568 45.0964 46.3164 45.5776 48.7425 46.8122C49.4205 47.1572 50.2135 46.9081 50.5137 46.2559C50.8139 45.6036 50.5077 44.7952 49.8298 44.4502C46.8759 42.947 43.9872 42.3961 40.2278 42.7169C39.4952 42.7794 38.9937 43.426 39.1078 44.1613C39.2219 44.8965 39.9083 45.4418 40.6409 45.3793Z"
        fill="#37241F"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M57.6428 25.6517C56.2811 25.5262 54.8756 25.7565 53.2509 26.4222C52.6467 26.6699 52.2811 27.4044 52.5045 28.2536L54.9451 37.5291C55.0481 37.9205 54.9729 38.3252 54.74 38.6326C54.507 38.9399 54.1408 39.1179 53.7412 39.1179H46.5731C45.8334 39.1179 45.1919 38.5198 45.1403 37.7819C45.0887 37.0441 45.6465 36.4459 46.3862 36.4459H51.9323L49.9097 28.7593C49.4074 26.8503 50.1461 24.7349 52.084 23.9408C54.0014 23.155 55.8283 22.8182 57.7047 22.9911C59.5753 23.1635 61.3929 23.8331 63.2961 24.9062C63.9598 25.2803 64.2298 26.0992 63.8991 26.7352C63.5685 27.3711 62.7625 27.5833 62.0988 27.2091C60.4367 26.272 59.0104 25.7777 57.6428 25.6517Z"
        fill="#37241F"
      />
      <g filter="url(#filter0_ddddd_13170_10524)">
        <path
          d="M114.405 81.4099C113.367 96.2485 100.467 108.278 85.5925 108.278C70.7177 108.278 59.5004 96.2485 60.538 81.4099C61.5756 66.5713 74.4752 54.5422 89.35 54.5422C104.225 54.5422 115.442 66.5713 114.405 81.4099Z"
          fill="url(#paint0_radial_13170_10524)"
        />
      </g>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M77.7172 77.8689H75.4555C74.8637 77.8689 74.3339 78.346 74.272 78.9345L73.4138 87.0995C72.919 91.8075 76.3554 95.624 81.0893 95.624H89.734C94.4679 95.624 98.7066 91.8075 99.2014 87.0995L100.06 78.9345C100.121 78.346 99.6919 77.8689 99.1001 77.8689H96.6859L96.9785 75.0845C97.5261 69.8751 93.7236 65.6521 88.4856 65.6521C83.2475 65.6521 78.5573 69.8751 78.0098 75.0845L77.7172 77.8689ZM80.9314 77.8689H93.4716L93.7642 75.0845C94.1262 71.6406 91.6124 68.8488 88.1496 68.8488C84.6867 68.8488 81.5861 71.6406 81.2241 75.0845L80.9314 77.8689ZM89.3509 84.0953C89.2555 85.003 88.7325 85.8088 88.0017 86.315L87.7615 88.6002C87.6688 89.483 86.874 90.1986 85.9864 90.1986H85.8533C84.9657 90.1986 84.3213 89.483 84.4141 88.6002L84.6543 86.3149C84.03 85.8087 83.6765 85.0029 83.7718 84.0953C83.9329 82.5632 85.3123 81.3211 86.8529 81.3211C88.3936 81.3211 89.5119 82.5632 89.3509 84.0953Z"
        fill="white"
      />
    </g>
    <defs>
      <filter
        id="filter0_ddddd_13170_10524"
        x="43.6714"
        y="52.9422"
        width="73.1995"
        height="82.5354"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-0.8" dy="0.8" />
        <feGaussianBlur stdDeviation="1.2" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.937255 0 0 0 0 0.145098 0 0 0 0 0.0901961 0 0 0 0.47 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_13170_10524" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-1.6" dy="3.2" />
        <feGaussianBlur stdDeviation="2" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.937255 0 0 0 0 0.145098 0 0 0 0 0.0901961 0 0 0 0.41 0" />
        <feBlend mode="normal" in2="effect1_dropShadow_13170_10524" result="effect2_dropShadow_13170_10524" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-4" dy="7.2" />
        <feGaussianBlur stdDeviation="2.4" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.937255 0 0 0 0 0.145098 0 0 0 0 0.0901961 0 0 0 0.24 0" />
        <feBlend mode="normal" in2="effect2_dropShadow_13170_10524" result="effect3_dropShadow_13170_10524" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-6.4" dy="12.8" />
        <feGaussianBlur stdDeviation="2.8" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.937255 0 0 0 0 0.145098 0 0 0 0 0.0901961 0 0 0 0.07 0" />
        <feBlend mode="normal" in2="effect3_dropShadow_13170_10524" result="effect4_dropShadow_13170_10524" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-10.4" dy="20.8" />
        <feGaussianBlur stdDeviation="3.2" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.937255 0 0 0 0 0.145098 0 0 0 0 0.0901961 0 0 0 0.01 0" />
        <feBlend mode="normal" in2="effect4_dropShadow_13170_10524" result="effect5_dropShadow_13170_10524" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect5_dropShadow_13170_10524" result="shape" />
      </filter>
      <radialGradient
        id="paint0_radial_13170_10524"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(116.335 44.5162) rotate(125.399) scale(85.1553 92.4805)"
      >
        <stop offset="0.172059" stop-color="#FFAFAA" />
        <stop offset="0.447221" stop-color="#F13E33" />
        <stop offset="0.712138" stop-color="#ED0E00" />
        <stop offset="1" stop-color="#FFD171" />
      </radialGradient>
      <clipPath id="clip0_13170_10524">
        <rect width="120" height="120" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
